import { ChainNetworkType as e } from "../../constants/chain.js";
import * as o from "yup";
const r = o.mixed().oneOf(Object.values(e)).default(e.Ronin);
export {
  r as chainNetworkTypeSchema
};
//# sourceMappingURL=chain.js.map
